'use client';

import React from 'react';
import { FormattedNumberInput } from '@/components/ui/FormattedNumberInput';

export const AnnualPaymentInputs = ({
  annualPayments,
  handlePaymentInputChange,
  handleDeletePayment,
}) => {
  return (
    <>
      {annualPayments.map((payment, index) => (
        <div
          key={payment.id}
          className={`grid ${
            index === 0
              ? 'md:grid-cols-[4.5fr_4.5fr] lg:grid-cols-[6.5fr_6.5fr]'
              : 'md:grid-cols-[6fr_4.5fr_1fr] lg:grid-cols-[7.7fr_6.5fr_auto]'
          } md:gap-8`}
        >
          <div>
            <p className="text-[#0C0D1A] text-base font-medium pt-10 mb-2">
              Repayment amount:
            </p>
            <FormattedNumberInput
              name={`repaymentAmount-${payment.id}`}
              value={payment.repaymentAmount}
              onChange={(_name, value) => {
                handlePaymentInputChange(payment.id, 'repaymentAmount', value);
              }}
              prefix="£"
              ariaLabel="Annual repayment amount"
            />
          </div>

          <div className="mt-8 md:mt-0">
            <div className="mt-8 md:mt-0">
              <p className="text-[#0C0D1A] text-base font-medium md:pt-10 mb-2">
                Year to apply payment:
              </p>
              <div className="relative w-full">
                <select
                  name={`yearToApplyPayment-${payment.id}`}
                  value={payment.yearToApplyPayment || ''}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    handlePaymentInputChange(payment.id, 'yearToApplyPayment', value);
                  }}
                  aria-label="Year to apply payment"
                  className="w-full bg-white p-[0.8rem] rounded-lg placeholder-[#5B5D6B] border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none pr-[2.8rem]"
                >
                  <option value="">Select year</option>
                  {Array.from({ length: 30 }, (_, i) => i + 1).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                <div className="absolute right-[15px] top-1/2 -translate-y-1/2 pointer-events-none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21" height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M5.33337 7.5L10.3334 12.5L15.3334 7.5"
                      stroke="#0C0D1A" strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Delete button - visible only for rows beyond the first */}
          {annualPayments.length > 1 && index > 0 && (
            <div className="mt-8 md:mt-0 md:pt-[4.5rem]">
              <button
                type="button"
                className="h-full rounded-xl bg-[#FDFDFF] border-[2px] border-[#CBCDD6] flex items-center justify-center p-2"
                style={{ width: '52px' }}
                onClick={() => handleDeletePayment(payment.id)}
              >
                <img
                  src="/img/icons/trash-03.svg"
                  alt="trash"
                  className="w-5 h-5"
                  loading="lazy"
                />
              </button>
            </div>
          )}
        </div>
      ))}
    </>
  );
};
